import { render, staticRenderFns } from "./paymentsettings.vue?vue&type=template&id=4ca631b8&scoped=true"
import script from "./paymentsettings.vue?vue&type=script&lang=js"
export * from "./paymentsettings.vue?vue&type=script&lang=js"
import style0 from "./paymentsettings.vue?vue&type=style&index=0&id=4ca631b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca631b8",
  null
  
)

export default component.exports